import { z } from 'zod';

const ServiceabilitySchema = z.object({
    pickupPincode: z.preprocess(
        (val) => {
            // If the value is an empty string, return undefined to trigger the required_error
            if (typeof val === "string" && val.trim() === "") return undefined;
            return Number(val);
        },
        z.number({ required_error: "Pickup pincode is required" })
        .int({ message: "Pickup pincode must be an integer" })
        .refine(val => val >= 100000 && val <= 999999, {
            message: "Pickup pincode must be exactly 6 digits",
        })
    ),
    deliveryPincode: z.preprocess(
        (val) => {
            if (typeof val === "string" && val.trim() === "") return undefined;
            return Number(val);
        },
        z.number({ required_error: "Delivery pincode is required" })
        .int({ message: "Delivery pincode must be an integer" })
        .refine(val => val >= 100000 && val <= 999999, {
            message: "Delivery pincode must be exactly 6 digits",
        })
    ),
});

export default ServiceabilitySchema;